/*
 * The reminder is two flat sibling fields on the scheda and controllo
 * conformita DTOs - promemoriaStileVisivo and promemoriaMessaggio - and it
 * keeps that flat shape all the way up to the components, under English names.
 * The pair still has to be judged as a unit, so every "is it there / is it
 * half-written" decision lives here rather than being re-derived per call site.
 */

export const isReminderComplete = (reminderStyle, reminderMessage) =>
  !!reminderStyle && !!reminderMessage?.trim();

export const isReminderEmpty = (reminderStyle, reminderMessage) =>
  !reminderStyle && !reminderMessage?.trim();

export const isReminderPartial = (reminderStyle, reminderMessage) =>
  !isReminderEmpty(reminderStyle, reminderMessage) &&
  !isReminderComplete(reminderStyle, reminderMessage);

export const areRemindersEqual = (a, b) =>
  (a?.reminderStyle ?? null) === (b?.reminderStyle ?? null) &&
  (a?.reminderMessage?.trim() ?? '') === (b?.reminderMessage?.trim() ?? '');

/**
 * Both halves travel together: a complete reminder is trimmed and kept, and
 * anything else - empty or half-written - collapses to a pair of nulls, so a
 * removal is expressed exactly the way an absent reminder reads back.
 */
export const normalizeReminder = (reminderStyle, reminderMessage) =>
  isReminderComplete(reminderStyle, reminderMessage)
    ? { reminderStyle, reminderMessage: reminderMessage.trim() }
    : { reminderStyle: null, reminderMessage: null };

/**
 * The API owns the Italian field names; everything above this boundary uses the
 * English pair. Partial records the API may hold are discarded on the way in.
 */
export const reminderFromDto = (dto) =>
  normalizeReminder(dto?.promemoriaStileVisivo, dto?.promemoriaMessaggio);

export const reminderToDto = (reminderStyle, reminderMessage) => {
  const normalized = normalizeReminder(reminderStyle, reminderMessage);

  return {
    promemoriaStileVisivo: normalized.reminderStyle,
    promemoriaMessaggio: normalized.reminderMessage,
  };
};
